import * as Shared from '@shared/lib';
import i18next from 'i18next';

export function getLootdropData(drop: Shared.LootDropMessage) {
  const amount = drop.amount ?? 1;

  if (drop.type === Shared.LootDropType.Item) {
    const data = Shared.dropData.find(d => d.id === drop.id);
    if (!data) return null;

    const name = i18next.t(`Items.${data.key}`);
    const dropImage = data.key;
    return { ...data, ...drop, name, amount, dropImage };
  }

  const data = Shared.modData.find(d => d.id === drop.id);
  if (!data) return null;

  const name = i18next.t(`Mods.${data.key}.name`);
  const dropImage = 'mod';
  return { ...data, ...drop, name, amount, dropImage };
}